import Vue from 'vue'
import Router from 'vue-router'
import login from './login'
import incrustado from './incrustado'
import reservas from './reservas'
import configuracion from './configuracion'
import comerciales from './comerciales'
import promociones from './promociones'
import index from '@/pages/index'
import beforeEach from './beforeEach'
import {store} from '@/store/store'

Vue.use(Router)

const router = new Router({
  routes: [
    ...login,
    ...incrustado,
    ...reservas,
    ...configuracion,
    ...comerciales,
    ...promociones,
    {
      path: '/',
      component: index,
      name: 'home',
      meta: {
        requiresAuth: true
      },
      beforeEnter: async (to, from, next) => {
        if (!store.getters['login/esAdministrador']) {
          store.dispatch('login/setComprobandoNumReservas', true)
          let reservaUnica = await store.dispatch('login/comprobarNumeroReservas')
          store.dispatch('login/setComprobandoNumReservas', false)
          if (reservaUnica.id == null) {
            next({name: 'reservas.list', replace: true})
          } else {
            next({name: 'reservas.id', replace: true, params: { id: reservaUnica.id, skip: true }})
          }
        } else {
          next()
        }
      }
    },
    {
      path: '*', // 404 Not found
      redirect: {name: 'home'}
    }
  ],
  scrollBehavior () {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 })
      }, 200)
    })
  },
  mode: 'history',
  base: process.env.STATIC_PATH_PREFIX
})

router.beforeEach(beforeEach) // Comprueba permisos

export default router



// WEBPACK FOOTER //
// ./src/router/index.js